import { useState, useEffect } from 'react';

export function useCountdownMs(startTime, durationMs) {
   const [timeLeftMs, setTimeLeftMs] = useState(0);

   useEffect(() => {
      // Verifica que startTime y durationMs sean válidos
      if (!startTime || typeof durationMs !== 'number' || durationMs <= 0) {
         setTimeLeftMs(0);
         return;
      }

      const start = new Date(startTime).getTime();
      const end = start + durationMs;

      const updateCountdown = () => {
         const now = Date.now();
         const remaining = Math.max(0, end - now);
         setTimeLeftMs(remaining);
      };

      updateCountdown(); // Inicial
      const interval = setInterval(updateCountdown, 1000);

      return () => clearInterval(interval);
   }, [startTime, durationMs]);

   const totalSeconds = Math.floor(timeLeftMs / 1000);
   const hours = Math.floor(totalSeconds / 3600);
   const minutes = Math.floor((totalSeconds % 3600) / 60);
   const seconds = totalSeconds % 60;

   return { hours, minutes, seconds, timeLeftMs };
}